import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { createApp } from "vue";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
// import "element-plus/dist/index.css";
// import "./assets/css/index.scss";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import DashboardLayout from './layouts/DashboardLayout.vue'
import DetailRecordLayout from './layouts/DetailRecordLayout.vue'
import DefaultLayout from './layouts/DefaultLayout.vue'
import DashboardRTL from './layouts/DashboardRTL.vue'

import './scss/app.scss';

const app = createApp(App);
app.use(createPinia());
app.use(Antd);

app.component("layout-default", DefaultLayout);
app.component("layout-dashboard", DashboardLayout);
app.component("layout-detail", DetailRecordLayout);
app.component("layout-dashboard-rtl", DashboardRTL);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(router);
app.use(ElementPlus);
app.mount("#app");
